module.exports = __webpack_public_path__ + "media/icon-targate.e27ef163.svg";